import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import useUnitProvider from '/@/core/context/unit';
import { _ } from '/@/locale';
import { formatDate, isPhone } from '/@/utils';
import styles from './styles.module.css';

/** @param {typeof propTypes} props */
function RecommendationInfo(props) {
    const {
        padding = true,
        actions,
        productRecommendations,
        cropConfig,
        brand,
        inline,
        useUnitProviderProps,
        isPdf = false,
    } = props;
    const units = useUnitProvider(useUnitProviderProps);
    const phone = isPhone();

    return (
        <div
            className={classNames(styles.root, styles[`theme-${brand.theme}`], {
                [styles.inline]: inline,
                [styles.padding]: padding,
            })}
        >
            <div className={styles.body}>
                <div>
                    <div className={styles.label}>{cropConfig.crop === 'corn' ? _('Híbridos') : _('Variedades')}</div>
                    <div className={styles.value}>
                        {productRecommendations.map((productRecommendation, idx) => {
                            const showSpacer = idx + 1 < productRecommendations.length;
                            return (
                                <Fragment key={productRecommendation.id}>
                                    {productRecommendation.profile.product.catalogName}
                                    {phone && showSpacer && <br />}
                                    {!phone && showSpacer && ', '}
                                </Fragment>
                            );
                        })}
                    </div>
                </div>
                <div>
                    <div className={styles.label}>{_('Fecha de siembra')}</div>
                    <div className={styles.value}>{formatDate(new Date(cropConfig.plantingDate))}</div>
                </div>
                <div>
                    <div className={styles.label}>{_('Ambiente')}</div>
                    <div className={styles.value}>
                        {units.toYield(cropConfig.environment, cropConfig.crop).toString()}
                    </div>
                </div>
            </div>
            {isPdf && <div className={styles.actions}>{actions}</div>}
        </div>
    );
}

const propTypes = {
    cropConfig: PropTypes.object.isRequired,
    productRecommendations: PropTypes.array.isRequired,
    padding: PropTypes.bool,
    inline: PropTypes.bool,
    recommendation: PropTypes.objectOf(PropTypes.shape({ id: PropTypes.number })),
};
RecommendationInfo.propTypes = propTypes;

export default RecommendationInfo;
